import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsState } from '../../reducers/literals.reducer';
import * as selectors from '../../selectors/literals/system.literals.selectors';

@Injectable({
  providedIn: 'root',
})
export class SystemLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  systemSave$ = this.storeSelect(selectors.getSystemSave);
  systemCancel$ = this.storeSelect(selectors.getSystemCancel);
  update$ = this.storeSelect(selectors.getUpdate);
  validate$ = this.storeSelect(selectors.getSystemValidate);
  searchFilters$ = this.storeSelect(selectors.getSystemSearchFilters);
  selectValue$ = this.storeSelect(selectors.getSystemSelectValue);
  clear$ = this.storeSelect(selectors.getSystemClear);
  createNew$ = this.storeSelect(selectors.getSystemCreateNew);
  search$ = this.storeSelect(selectors.getSystemSearch);
  couponSet$ = this.storeSelect(selectors.getSystemCouponSet);
  sure$ = this.storeSelect(selectors.getSystemSure);
  aboutDeactivate$ = this.storeSelect(selectors.getAboutDeactivate);
  no$ = this.storeSelect(selectors.getSystemNo);
  yes$ = this.storeSelect(selectors.getSystemYes);
  noResultsFound$ = this.storeSelect(selectors.getSystemNoResultsFound);
  systemDelete$ = this.storeSelect(selectors.getSystemDelete);
  inputValidation$ = this.storeSelect(selectors.getSystemInputValidation);
  systemEmailValidation$ = this.storeSelect(selectors.getSystemEmailValidation);
  systemSaveSuccess$ = this.storeSelect(selectors.getSystemSaveSuccess);
  systemSaveFailed$ = this.storeSelect(selectors.getSystemSaveFailed);
  systemGridFailed$ = this.storeSelect(selectors.getSystemGridFailed);
  systemClose$ = this.storeSelect(selectors.getSystemClose);
  file$ = this.storeSelect(selectors.getFile);
  size$ = this.storeSelect(selectors.getSize);
  uploadedFileEmpty$ = this.storeSelect(selectors.getUploadedFileEmpty);
  attribute$ = this.storeSelect(selectors.getAttribute);
  updateIntegration$ = this.storeSelect(selectors.getUpdateIntegration);
  uploadingFile$ = this.storeSelect(selectors.getUploadingFile);
  create$ = this.storeSelect(selectors.getSystemCreate);
  assign$ = this.storeSelect(selectors.getSystemAssign);
  createList$ = this.storeSelect(selectors.getCreateList);
  submit$ = this.storeSelect(selectors.getSubmit);
  uid$ = this.storeSelect(selectors.getUID);
  emailValidation$ = this.storeSelect(selectors.getEmailValidation);
  jsonEditor$ = this.storeSelect(selectors.getJsonEditor);
  uploadFile$ = this.storeSelect(selectors.getUploadFile);
  invalidValue$ = this.storeSelect(selectors.getInvalidValue);

  // OBSERVABLE'S VALUES

  get noResultsFound() {
    return this.storeSnapshot(this.noResultsFound$);
  }

  get systemSaveSuccess() {
    return this.storeSnapshot(this.systemSaveSuccess$);
  }

  get systemSaveFailed() {
    return this.storeSnapshot(this.systemSaveFailed$);
  }

  get systemGridFailed() {
    return this.storeSnapshot(this.systemGridFailed$);
  }

  get systemClose() {
    return this.storeSnapshot(this.systemClose$);
  }

  get yes() {
    return this.storeSnapshot(this.yes$);
  }

  get no() {
    return this.storeSnapshot(this.no$);
  }

  get systemCancel() {
    return this.storeSnapshot(this.systemCancel$);
  }

  get systemDelete() {
    return this.storeSnapshot(this.systemDelete$);
  }

  get clear() {
    return this.storeSnapshot(this.clear$);
  }

  get createNew() {
    return this.storeSnapshot(this.createNew$);
  }

  get search() {
    return this.storeSnapshot(this.search$);
  }
}
